// extracted by mini-css-extract-plugin
export default {"forward":"ForwardPart_forward__ZiUWh","img":"ForwardPart_img__t0qHO"};